<template>
    <div class="mobile_c">
        <van-nav-bar title="广材帮" placeholder fixed>
            <template #left>
                <van-icon @click="goindex" name="wap-home-o" size="22" color="#000" />
            </template>
        </van-nav-bar>
        <div class="tim_userlist">
            <div class="itmes" :class="nowUserID == item.userProfile.userID ? 'active' : ''"
                v-for="(item, index) in userList" :key="index" @click="getToUserInfo(item)">
                <div class="items_img">
                    <el-badge :value="item.unreadCount" class="item" v-if="item.unreadCount != 0">
                        <img :src="item.userProfile.avatar" alt="" srcset="">
                    </el-badge>
                    <img :src="item.userProfile.avatar" alt="" srcset="" v-else>
                </div>
                <div class="items_cont">
                    <div class="items_top">
                        <div class="items_name">{{ item.userProfile.nick }}</div>
                        <div v-if="item.lastMessage" class="items_time">{{ item.lastMessage.lastTime | dateFormat }}
                        </div>
                    </div>
                    <div class="items_text" v-if="item.lastMessage">
                        <div v-if="item.lastMessage.isRevoke">
                            <span >[消息已被撤回]</span>
                        </div>
                        <div v-else>
                            <span v-if="datatype(item) == 'image'">[图片]</span>
                            <span v-if="datatype(item) == 'file'">[文件]</span>
                            <span v-if="datatype(item) == 'system'">[系统提示]{{item.lastMessage.payload.data }}</span>
                            <span v-if="datatype(item) == 'link_text'">[自定义消息]</span>
                            <span v-if="datatype(item) == 'default'">{{
                                item.lastMessage.payload.data }}</span>
                        </div>
                    </div>

                </div>
            </div>
            <div class="kongts" v-if="userList.length == ''">
                <div>
                    <img src="../../assets/tim/leftkong.png" alt="" srcset="">
                    <div class="texts">
                        暂无会话信息
                    </div>
                </div>
            </div>

        </div>
        <Tabbar :uactive="0"></Tabbar>
    </div>
</template>

<script>
import Tabbar from '@/components/TimMobile/tabbar.vue';
import { mapState } from 'vuex'
export default {
    components: {
        Tabbar
    },
    name: '',
    data() {
        return {
            nowUserID: '',
            userList: [],
        }
    },
    computed: {
        ...mapState(['userinfo']),
        datatype() {
            return (item) => {
                if (item.lastMessage) {
                    let type = JSON.parse(item.lastMessage.payload.extension).dataType
                    return type
                } else {
                    return ''
                }
            }
        }
    },
    mounted() {
        this.monitor()
        if(this.tim.IsVaild){
            this.getlist()
        }
    },
    methods: {
        monitor() {
            let conversationList = (event) => {
                this.userList = event.data
            };
            // 监听会话列表
            this.tim.on(this.TIM.EVENT.CONVERSATION_LIST_UPDATED, conversationList)

            this.tim.on(this.TIM.EVENT.LOGIN_SUC, this.onLogin)
        },

        onLogin(){
            this.getlist()
        },

        getlist() {
            let that = this
            let promise = that.tim.getConversationList();
            promise.then((imResponse) => {
                let conversationList = imResponse.data.conversationList;
                that.userList = conversationList

                const toUser = sessionStorage.getItem('touser');
                if(toUser)
                {
                    setTimeout(() => {
                    this.$dataConver.gopage(toUser);
                    sessionStorage.removeItem('touser');
                    }, 1000);
                }

            }).catch((imError) => { console.log(imError) });
        },
        goindex() {
            // this.$router.go(-1)
            this.$router.push({ path: "/" }).catch(() => { });
        },
        getToUserInfo(item) {
            localStorage.setItem('hyinfo',JSON.stringify(item))
            this.$router.push({ path: "/indexdetail", query: item }).catch(() => { });
        }
    },
}
</script>
<style lang='scss' scoped>
.mobile_c {
    width: 100%;
}

.kongts {
    display: flex;
    justify-content: center;
    align-items: center;
    height:700px;
    text-align: center;
    width: 100%;
    img {
        width: 46px;
        height: 46px;
    }

    .texts {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        line-height: 46px;
    }
}


.tim_userlist {
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;

    &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
    }

    // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
    &::-webkit-scrollbar-thumb {
        background: rgba(144, 147, 153, 0.3);
        cursor: pointer;
        border-radius: 4px;
    }

    .active {
        background-color: #eee !important;
    }

    .itmes {
        width: 100%;
        margin: 0 auto 10px;
        padding: 10px;
        display: flex;
        box-sizing: border-box;
        border-radius: 10px;
        overflow: hidden;

        .items_img {
            width: 50px;
            height: 50px;
            border-radius: 10px;

            img {
                width: 50px;
                height: 50px;
                border-radius: 10px;
            }
        }

        .items_cont {
            flex: 1;
            margin-left: 5px;
            height: 50px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        .items_top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .items_name {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 14px;
                color: #000000;
                width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .items_time {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #ADAAAA;
            }
        }

        .items_text {
            width: 260px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #ADAAAA;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: flex;
            align-items: center;

            div {
                width: 260px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .itmes:active {
        background: #f4f4f4;
    }
}
</style>